export enum RequiredCannedQuestionId {
    firstName = 'first_name',
    lastName = 'last_name',
    email = 'email',
    cc = 'cc',
    bill = 'bill',
}
